export function getdata() {
	let obj = {
		searchlist: [{
			prop: "test1",
			label: '购/销方选择',
			type: "select",
			selectval: []
		}, {
			prop: "test1",
			label: '对方纳税人识别号',
			type: "input"
		}, {
			prop: "test1",
			label: '发票号码',
			type: "input"
		}, {
			prop: "test1",
			label: '对方纳税人名称',
			type: "input"
		}, {
			prop: "test7",
			label: '开票日期起',
			type: "realdate"
		}, {}, {
			prop: "test1",
			label: '发票代码',
			type: "input"
		}, {
			prop: "test1",
			label: '数电票号码',
			type: "input"
		}, {
			prop: "test7",
			label: '开票日期止',
			type: "realdate"
		}, ],
	}
	return obj
}
